import React from "react";
import { Link } from "react-router";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

function Footer() {
  const { t } = useTranslation(["common"]);

  return (
    <>
      <footer
        className={`${
          import.meta.env.VITE_PLATFORM === "mobile" ? "pb-20" : ""
        }`}
        style={{ contentVisibility: "auto" }}
      >
        <div className={`bg-surface-primary text-text-inverted py-7 lg:py-10`}>
          <div className="px-3 lg:container lg:mx-auto">
            <div className="flex flex-col gap-8">
              {import.meta.env.VITE_PLATFORM === "web" && (
                <div className="text-sm lg:text-lg w-full">
                  {t("footer.copyright")}
                </div>
              )}
              <div className="flex flex-row flex-wrap gap-8">
                <div className="grow">
                  <div>
                    <h2 className="font-semibold text-lg lg:text-2xl mb-5">
                      {t("footer.usefulLinks")}
                    </h2>
                    <ul className="lg:text-lg flex flex-col gap-3">
                      <li>
                        <Link
                          to="/merchandise"
                          className="underline underline-offset-2 hover:underline-offset-4 hover:decoration-2"
                        >
                          {t("footer.merchandise")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/privacy-policy"
                          className="underline underline-offset-2 hover:underline-offset-4 hover:decoration-2"
                        >
                          {t("footer.privacyPolicy")}
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/terms-of-service"
                          className="underline underline-offset-2 hover:underline-offset-4 hover:decoration-2"
                        >
                          {t("footer.termsOfService")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="grow">
                  <div>
                    <h2 className="font-semibold text-lg lg:text-2xl mb-5">
                      {t("footer.socialMedia")}
                    </h2>
                    <div className="flex items-center">
                      <div>
                        {/* Discord */}
                        <Link
                          to="https://discord.gg/HTA75aJqPB"
                          aria-label="Givin Gifts on Discord"
                        >
                          <svg
                            width="40"
                            height="32"
                            viewBox="0 0 40 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M33.8626 3.28702C31.2691 2.09599 28.5322 1.24641 25.7202 0.759549C25.6947 0.755259 25.6685 0.758964 25.6452 0.770156C25.6219 0.781348 25.6027 0.799476 25.5902 0.822048C25.2377 1.44704 24.8477 2.26453 24.5752 2.90453C21.5442 2.44493 18.4612 2.44493 15.4303 2.90453C15.1276 2.191 14.7837 1.49566 14.4003 0.822048C14.3877 0.799476 14.3685 0.781348 14.3452 0.770156C14.3219 0.758964 14.2957 0.755259 14.2703 0.759549C11.4578 1.24454 8.72033 2.09454 6.12786 3.28702C6.10556 3.2953 6.08695 3.31126 6.07536 3.33202C0.890413 11.0794 -0.532072 18.6369 0.165421 26.0993C0.17042 26.1359 0.18792 26.1668 0.21792 26.1918C3.23781 28.4273 6.61477 30.1348 10.2053 31.2417C10.2307 31.2497 10.2579 31.2494 10.2831 31.2409C10.3083 31.2324 10.3301 31.216 10.3453 31.1942C11.117 30.1442 11.7986 29.0368 12.3903 27.8718C12.4026 27.8478 12.4068 27.8204 12.4023 27.7939C12.3978 27.7673 12.3848 27.7429 12.3653 27.7243L12.3203 27.6968C11.2437 27.2817 10.2006 26.7844 9.20033 26.2093C9.1724 26.1935 9.15164 26.1675 9.14233 26.1368C9.13302 26.1061 9.13588 26.0729 9.15033 26.0443L9.18783 25.9968C9.39949 25.8385 9.60615 25.676 9.80782 25.5093C9.82549 25.4951 9.84668 25.486 9.86914 25.4829C9.8916 25.4798 9.91448 25.4829 9.93532 25.4918C16.4827 28.4818 23.5702 28.4818 30.0376 25.4918C30.0591 25.4819 30.0829 25.4782 30.1064 25.4813C30.1298 25.4844 30.1519 25.4941 30.1701 25.5093C30.3718 25.676 30.5784 25.8385 30.7901 25.9968C30.8077 26.0088 30.8219 26.0252 30.8314 26.0442C30.8409 26.0633 30.8454 26.0845 30.8444 26.1058C30.8434 26.1271 30.8369 26.1478 30.8257 26.1659C30.8144 26.184 30.7987 26.1989 30.7801 26.2093C29.7841 26.7935 28.7394 27.2903 27.6576 27.6943C27.6404 27.7005 27.6247 27.7105 27.6118 27.7234C27.5988 27.7364 27.5889 27.752 27.5826 27.7693C27.5765 27.7859 27.5741 27.8036 27.5754 27.8213C27.5767 27.839 27.5817 27.8562 27.5901 27.8718C28.1901 29.0343 28.8776 30.1442 29.6326 31.1942C29.6479 31.216 29.6697 31.2324 29.6948 31.2409C29.72 31.2494 29.7473 31.2497 29.7726 31.2417C33.3702 30.1409 36.7531 28.433 39.775 26.1918C39.79 26.1812 39.8025 26.1674 39.8116 26.1514C39.8207 26.1354 39.8261 26.1176 39.8275 26.0993C40.6625 17.4719 38.43 9.97695 33.9126 3.33452C33.9086 3.32318 33.9021 3.31295 33.8933 3.30468C33.8846 3.29642 33.8741 3.29036 33.8626 3.28702ZM13.3678 21.5543C11.3953 21.5543 9.77282 19.7444 9.77282 17.5244C9.77282 15.3044 11.3653 13.4919 13.3678 13.4919C15.3853 13.4919 16.9927 15.3169 16.9627 17.5244C16.9627 19.7444 15.3703 21.5543 13.3678 21.5543ZM26.6576 21.5543C24.6877 21.5543 23.0627 19.7444 23.0627 17.5244C23.0627 15.3044 24.6552 13.4919 26.6576 13.4919C28.6751 13.4919 30.2851 15.3169 30.2526 17.5244C30.2526 19.7444 28.6751 21.5543 26.6576 21.5543Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Link>
                      </div>
                      <div className="ml-5">
                        {/* Reddit */}
                        <Link
                          to="https://www.reddit.com/r/givingifts/"
                          aria-label="Givin Gifts on Reddit"
                        >
                          <svg
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M40 20.0024C40 25.3068 37.8929 30.3939 34.1421 34.1446C30.3914 37.8953 25.3043 40.0024 20 40.0024C14.6957 40.0024 9.60859 37.8953 5.85786 34.1446C2.10714 30.3939 0 25.3068 0 20.0024C0 14.6981 2.10714 9.61103 5.85786 5.86031C9.60859 2.10958 14.6957 0.00244141 20 0.00244141C25.3043 0.00244141 30.3914 2.10958 34.1421 5.86031C37.8929 9.61103 40 14.6981 40 20.0024ZM30.43 17.0899C29.6425 17.0899 28.925 17.3999 28.4 17.9024C26.3975 16.4699 23.65 15.5399 20.5975 15.4199L21.9325 9.16744L26.2775 10.0974C26.2966 10.5031 26.4343 10.8943 26.6736 11.2225C26.9129 11.5507 27.2432 11.8014 27.6237 11.9436C28.0041 12.0858 28.4179 12.1132 28.8138 12.0225C29.2097 11.9318 29.5702 11.7268 29.8507 11.4331C30.1313 11.1394 30.3194 10.7699 30.3919 10.3702C30.4644 9.9706 30.418 9.55849 30.2585 9.18498C30.099 8.81147 29.8333 8.49298 29.4945 8.269C29.1557 8.04502 28.7586 7.92539 28.3525 7.92494C27.964 7.9263 27.5837 8.03668 27.2549 8.24352C26.9261 8.45037 26.6619 8.74536 26.4925 9.09494L21.6475 8.06994C21.5823 8.05547 21.5149 8.05421 21.4492 8.06623C21.3835 8.07826 21.3208 8.10332 21.265 8.13994C21.2081 8.17808 21.1597 8.2275 21.1227 8.28512C21.0857 8.34275 21.061 8.40736 21.05 8.47494L19.57 15.4449C16.47 15.5399 13.675 16.4699 11.645 17.9249C11.12 17.4249 10.405 17.1149 9.62 17.1149C8.95426 17.114 8.30835 17.3415 7.79019 17.7595C7.27203 18.1775 6.91301 18.7606 6.77312 19.4115C6.63323 20.0624 6.72094 20.7415 7.0216 21.3355C7.32226 21.9295 7.81765 22.4023 8.425 22.6749C8.375 22.9583 8.35083 23.2524 8.3525 23.5574C8.3525 28.0449 13.58 31.6974 20.025 31.6974C26.47 31.6974 31.695 28.0699 31.695 23.5574C31.695 23.2724 31.67 22.9624 31.6225 22.6749C32.625 22.2224 33.3425 21.1949 33.3425 20.0024C33.3425 18.3774 32.03 17.0899 30.43 17.0899Z"
                              fill="currentColor"
                            />
                            <path
                              d="M15.4175 20.0024C15.145 20.0024 14.8752 20.0561 14.6234 20.1604C14.3717 20.2647 14.1429 20.4175 13.9502 20.6102C13.7576 20.8029 13.6047 21.0316 13.5004 21.2834C13.3962 21.5351 13.3425 21.8049 13.3425 22.0774C13.3425 23.2249 14.2725 24.1774 15.4175 24.1549C15.9557 24.1363 16.4656 23.9093 16.8397 23.522C17.2138 23.1347 17.4229 22.6172 17.4229 22.0787C17.4229 21.5402 17.2138 21.0227 16.8397 20.6354C16.4656 20.248 15.9557 20.0211 15.4175 20.0024ZM20.025 29.1199C20.8125 29.1199 23.5325 29.0249 24.965 27.5924C25.0588 27.4871 25.1107 27.351 25.1107 27.2099C25.1107 27.0689 25.0588 26.9328 24.965 26.8274C24.9153 26.7762 24.8559 26.7354 24.7902 26.7076C24.7245 26.6798 24.6539 26.6654 24.5825 26.6654C24.5111 26.6654 24.4405 26.6798 24.3748 26.7076C24.3091 26.7354 24.2496 26.7762 24.2 26.8274C23.3175 27.7349 21.385 28.0449 20.025 28.0449C18.6625 28.0449 16.755 27.7349 15.8475 26.8274C15.7978 26.7762 15.7384 26.7354 15.6727 26.7076C15.607 26.6798 15.5364 26.6654 15.465 26.6654C15.3936 26.6654 15.323 26.6798 15.2573 26.7076C15.1916 26.7354 15.1321 26.7762 15.0825 26.8274C15.0312 26.8771 14.9905 26.9365 14.9626 27.0022C14.9348 27.0679 14.9205 27.1386 14.9205 27.2099C14.9205 27.2813 14.9348 27.3519 14.9626 27.4176C14.9905 27.4834 15.0312 27.5428 15.0825 27.5924C16.4925 28.9999 19.2125 29.1174 20.025 29.1174V29.1199ZM22.505 22.1024C22.505 23.2474 23.4375 24.1774 24.5825 24.1774C25.7275 24.1774 26.6575 23.2249 26.6575 22.1024C26.6313 21.5697 26.4013 21.0675 26.015 20.6997C25.6288 20.332 25.1158 20.1268 24.5825 20.1268C24.0491 20.1268 23.5362 20.332 23.15 20.6997C22.7637 21.0675 22.5336 21.5697 22.5075 22.1024H22.505Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Link>
                      </div>
                      <div className="ml-5">
                        {/* TikTok */}
                        <Link
                          to="https://www.tiktok.com/@givingifts4?_t=8pgy9QaBcNF&_r=1"
                          aria-label="Givin Gifts on TikTok"
                        >
                          <svg
                            width="33"
                            height="38"
                            viewBox="0 0 33 38"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M28.4556 8.02031C28.2024 7.88949 27.956 7.74608 27.7173 7.59062C27.0229 7.13161 26.3863 6.59074 25.8212 5.97969C24.4071 4.36172 23.879 2.72031 23.6845 1.57109H23.6923C23.5298 0.617187 23.597 0 23.6071 0H17.1665V24.9047C17.1665 25.2391 17.1665 25.5695 17.1524 25.8961C17.1524 25.9367 17.1485 25.9742 17.1462 26.018C17.1462 26.0359 17.1462 26.0547 17.1423 26.0734C17.1423 26.0781 17.1423 26.0828 17.1423 26.0875C17.0744 26.9811 16.7879 27.8443 16.3081 28.6012C15.8283 29.3581 15.1699 29.9854 14.3907 30.4281C13.5786 30.8901 12.6602 31.1325 11.7259 31.1312C8.72509 31.1312 6.29306 28.6844 6.29306 25.6625C6.29306 22.6406 8.72509 20.1937 11.7259 20.1937C12.2939 20.1932 12.8584 20.2826 13.3985 20.4586L13.4063 13.9008C11.7668 13.689 10.1011 13.8193 8.51444 14.2835C6.92776 14.7476 5.4545 15.5356 4.18759 16.5977C3.07748 17.5622 2.14421 18.713 1.42977 19.9984C1.1579 20.4672 0.132119 22.3508 0.00789989 25.4078C-0.0702251 27.143 0.450869 28.9406 0.699306 29.6836V29.6992C0.855556 30.1367 1.46102 31.6297 2.44774 32.8883C3.2434 33.8979 4.18344 34.7847 5.23759 35.5203V35.5047L5.25321 35.5203C8.37118 37.6391 11.8282 37.5 11.8282 37.5C12.4267 37.4758 14.4313 37.5 16.7079 36.4211C19.2329 35.225 20.6704 33.443 20.6704 33.443C21.5887 32.3782 22.319 31.1647 22.8298 29.8547C23.4126 28.3227 23.6071 26.4852 23.6071 25.7508V12.5383C23.6852 12.5852 24.7259 13.2734 24.7259 13.2734C24.7259 13.2734 26.2251 14.2344 28.5641 14.8602C30.2423 15.3055 32.5032 15.3992 32.5032 15.3992V9.00547C31.711 9.09141 30.1024 8.84141 28.4556 8.02031Z"
                              fill="currentColor"
                            />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/*<div className="mt-6">
                    <select className="bg-surface-primary text-text-inverted rounded-md p-2 border border-border-faint">
                      <option
                        value="en"
                        className="bg-surface-primary text-text-inverted"
                      >
                        English
                      </option>
                      <option
                        value="fr"
                        className="bg-surface-primary text-text-inverted"
                      >
                        French
                      </option>
                      <option
                        value="es"
                        className="bg-surface-primary text-text-inverted"
                      >
                        Spanish
                      </option>
                      <option
                        value="de"
                        className="bg-surface-primary text-text-inverted"
                      >
                        German
                      </option>
                      <option
                        value="it"
                        className="bg-surface-primary text-text-inverted"
                      >
                        Italian
                      </option>
                      <option
                        value="ja"
                        className="bg-surface-primary text-text-inverted"
                      >
                        Japanese
                      </option>
                      <option
                        value="zh"
                        className="bg-surface-primary text-text-inverted"
                      >
                        Chinese
                      </option>
                    </select>
                  </div>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <ToastContainer position="top-right" />
    </>
  );
}

export default Footer;
